import {IonicModule} from "@ionic/angular";
import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {RichTextEditorComponent} from "./rich-text-editor.component";
import {QuillModule} from "ngx-quill";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
    AudioTranscriptionModule
} from "../../../modules/common/audio/transcription/api/component/audio-transcription/audio-transcription.module";
import {
    AudioTranscriptionV2Component
} from "../../../modules/common/audio/transcription/api/component/audio-transcription-v2/audio-transcription-v2.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        QuillModule,
        AudioTranscriptionModule,
        AudioTranscriptionV2Component,
    ],
    declarations: [
        RichTextEditorComponent,
    ],
    exports: [
        RichTextEditorComponent
    ],
})
export class RichTextEditorModule{}